import { render, staticRenderFns } from "./tabpanel.vue?vue&type=template&id=76d1f316&"
import script from "./tabpanel.vue?vue&type=script&lang=js&"
export * from "./tabpanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports